export const font = {
  heading: {
    family: 'GTAmericaCompressed',
    weight: {
      medium: 500,
    },
  },
  headingAlt: {
    family: 'PPEditorial',
    weight: {
      light: 100,
    },
  },
  primary: {
    family: 'GTAmerica',
    weight: {
      regular: 400,
      medium: 500,
    },
  },
  fallback: {
    family: 'sans-serif',
  },
}
